import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { withRouter } from "../../_shared/withRouter";
import { Button } from "react-bootstrap";
import { activateAdminUserApi } from "../../admin/_actions";
import { activateSuperAdminUserApi } from "../../superadmin/_actions";
import { globalLoader, globalAlert, addOrgDetailsFunc } from "../../actions/commonActions";
import { userBrandInfo } from "../../user/_userActions";
import InputComponent from "../_common/inputComponent";
import { getAdminDefaultPath } from "../admin/sidebarVisibility";

const PASSWORD_MIN = 8;

const VerifyAccount = (props) => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [invalidEmail, setInvalidEmail] = useState(false);
  const [emptyEmail, setEmptyEmail] = useState(false);
  const [emptyCode, setEmptyCode] = useState(false);
  const [password, setPassword] = useState("");
  const [emptyPassword, setEmptyPassword] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [emptyConfirmPassword, setEmptyConfirmPassword] = useState(false);
  const [passwordMatch, setPasswordMatch] = useState(true);
  const [invalidPasswordPolicy, setInvalidPasswordPolicy] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  const [showPasswordRules, setShowPasswordRules] = useState(false);

  const passwordRules = [
    {
      key: "min",
      label: t("learner.lms.setPassword.ruleMin", "At least 8 characters"),
      ok: password.length >= PASSWORD_MIN,
    },
    {
      key: "upper",
      label: t("learner.lms.setPassword.ruleUpper", "One capital letter"),
      ok: /[A-Z]/.test(password),
    },
    {
      key: "lower",
      label: t("learner.lms.setPassword.ruleLower", "One small letter"),
      ok: /[a-z]/.test(password),
    },
    {
      key: "number",
      label: t("learner.lms.setPassword.ruleNumber", "One number"),
      ok: /[0-9]/.test(password),
    },
    {
      key: "special",
      label: t("learner.lms.setPassword.ruleSpecial", "One special character"),
      ok: /[^A-Za-z0-9]/.test(password),
    },
  ];

  const isPasswordPolicyValid = passwordRules.every((rule) => rule.ok);

  const resolveAdminLandingPath = async () => {
    try {
      const brandRes = await userBrandInfo();
      const orgBrandInfo = brandRes?.data?.data?.orgBrandInfo || {};
      if (Object.keys(orgBrandInfo).length) {
        addOrgDetailsFunc(orgBrandInfo);
      }
      return getAdminDefaultPath(orgBrandInfo);
    } catch (error) {
      return "/admin/manage-users";
    }
  };

  const handlePassword = (ev) => {
    setPassword(ev);
    setEmptyPassword(false);
    setInvalidPasswordPolicy(false);
    setShowPasswordRules(true);
    if (confirmPassword) {
      setPasswordMatch(ev === confirmPassword);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let valid = await handleValidation();
    if (valid) {
      globalLoader(true);
      let obj = {
        email: email,
        activationCode: code,
        password: password,
      };
      let res;
      if (props?.roleType === "superadmin") {
        res = await activateSuperAdminUserApi(obj);
        if (res?.data?.status === 200) {
          localStorage.setItem("portalRole", "superadmin");
          localStorage.setItem("userEmail", email);
          globalAlert("success", res?.data?.message);
          props.history.push("/superadmin/manage-organisations");
        } else {
          globalAlert("error", res?.data?.message);
          globalLoader(false);
        }
      } else if (props?.roleType === "admin") {
        res = await activateAdminUserApi(obj);
        if (res?.data?.status === 200) {
          localStorage.setItem("portalRole", "admin");
          localStorage.setItem("userEmail", email);
          globalAlert("success", res?.data?.message);
          if (res?.data?.data?.isMfaRequired) {
            props.history.push("/admin/login");
          } else {
            const nextPath = await resolveAdminLandingPath();
            props.history.push(nextPath);
          }
        } else {
          globalAlert("error", res?.data?.message);
          globalLoader(false);
        }
      }
    }
  };

  const handleValidation = () => {
    let flag = true;
    setInvalidPasswordPolicy(false);
    setPasswordMatch(true);
    if (!email) {
      setEmptyEmail(true);
      flag = false;
    }
    if (!code) {
      setEmptyCode(true);
      flag = false;
    }
    if (!password) {
      setEmptyPassword(true);
      flag = false;
    }
    if (password && !isPasswordPolicyValid) {
      setInvalidPasswordPolicy(true);
      setShowPasswordRules(true);
      flag = false;
    }
    if (!confirmPassword) {
      setEmptyConfirmPassword(true);
      flag = false;
    }
    if (password && confirmPassword && password !== confirmPassword) {
      setPasswordMatch(false);
      flag = false;
    }
    return flag;
  };

  return (
    <>
      <div className="auth-screen-wrapper">
        <div className="fix-width-wrapper px-3 mx-auto">
          <div className="auth-body-wrapper">
            <div className="logo-wrapper text-center">
              <img
                src="../assets/icons/eC-Card-Logo.svg"
                alt="EC Card Logo"
                className="logo"
              />
            </div>
            <form onSubmit={handleSubmit} className="form-own" autoComplete="off">
              <div className="pt-1">
                <p className="login-text text-center fw-bold">
                  {t("user.verifyAccount.enterDetails")}
                </p>
                <div className="form-group reg-date login-page">
                  <InputComponent
                    placeholder={t("user.verifyAccount.emailPlaceholder")}
                    label={t("user.verifyAccount.emailLabel")}
                    name="email"
                    type="text"
                    theme="primary"
                    color="#d7eff5"
                    inputFor="number"
                    maxLength={40}
                    value={email}
                    autoComplete="off"
                    handleCallback={(val, flag) => {
                      setInvalidEmail(flag);
                      setEmail(val);
                    }}
                  />
                  <div className="error-text font-12 pl-2">
                    {!email && emptyEmail && <span>{t("user.verifyAccount.emailRequired")}</span>}
                    {email && invalidEmail && <span>{t("user.verifyAccount.emailInvalid")}</span>}
                  </div>
                </div>
                <div className="form-group login-page">
                  <InputComponent
                    placeholder={t("user.verifyAccount.activationCodePlaceholder")}
                    label={t("user.verifyAccount.activationCodeLabel")}
                    name="activationCode"
                    type="text"
                    theme="primary"
                    color="#d7eff5"
                    value={code}
                    autoComplete="off"
                    autoCorrect="off"
                    autoCapitalize="none"
                    spellCheck={false}
                    handleCallback={(val) => setCode(val)}
                  />
                  <div className="error-text font-12 pl-2">
                    {!code && emptyCode && (
                      <span>{t("user.verifyAccount.activationCodeRequired")}</span>
                    )}
                  </div>
                </div>
                <div className="form-group position-relative login-page">
                  <InputComponent
                    placeholder={t("user.verifyAccount.passwordLabel")}
                    label={t("user.verifyAccount.passwordLabel")}
                    name="newAdminPassword"
                    type={passwordVisible ? "text" : "password"}
                    theme="primary"
                    color="#d7eff5"
                    value={password}
                    autoComplete="new-password"
                    handleCallback={(val) => {
                      handlePassword(val);
                    }}
                    onFocus={() => setShowPasswordRules(true)}
                    onBlur={() => setShowPasswordRules(false)}
                  />
                  <div
                    className="login-password cursor"
                    onClick={() => {
                      setPasswordVisible((current) => !current);
                    }}
                  >
                    {passwordVisible ? (
                      <i className="far fa-eye"></i>
                    ) : (
                      <i className="far fa-eye-slash"></i>
                    )}
                  </div>
                  {showPasswordRules && (
                    <div className="lms-password-popover" id="activate-password-policy">
                      <ul className="lms-password-rules">
                        {passwordRules.map((rule) => (
                          <li key={rule.key} className={rule.ok ? "active" : ""}>
                            <i className={`fas ${rule.ok ? "fa-check-circle" : "fa-circle"}`}></i>
                            <span>{rule.label}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                  <div className="error-text font-12 pl-2">
                    {!password && emptyPassword && (
                      <span>{t("user.verifyAccount.passwordRequired")}</span>
                    )}
                    {password && invalidPasswordPolicy && (
                      <span>
                        {t(
                          "learner.lms.errors.passwordPolicy",
                          "Password must include at least {{n}} characters, one capital letter, one small letter, one number and one special character.",
                          { n: PASSWORD_MIN }
                        )}
                      </span>
                    )}
                    {!passwordMatch && <span>{t("user.verifyAccount.passwordsDoNotMatch")}</span>}
                  </div>
                </div>
                <div className="form-group position-relative login-page">
                  <InputComponent
                    placeholder={t("user.verifyAccount.confirmPasswordLabel")}
                    label={t("user.verifyAccount.confirmPasswordLabel")}
                    name="confirmAdminPassword"
                    type={confirmPasswordVisible ? "text" : "password"}
                    theme="primary"
                    color="#d7eff5"
                    value={confirmPassword}
                    autoComplete="new-password"
                    handleCallback={(val) => {
                      setConfirmPassword(val);
                      setEmptyConfirmPassword(false);
                      if (password) {
                        setPasswordMatch(password === val);
                      }
                    }}
                  />
                  <div
                    className="login-password cursor"
                    onClick={() => {
                      setConfirmPasswordVisible((current) => !current);
                    }}
                  >
                    {confirmPasswordVisible ? (
                      <i className="far fa-eye"></i>
                    ) : (
                      <i className="far fa-eye-slash"></i>
                    )}
                  </div>
                  <div className="error-text font-12 pl-2">
                    {!confirmPassword && emptyConfirmPassword && (
                      <span>{t("user.verifyAccount.confirmPasswordRequired")}</span>
                    )}
                    {!passwordMatch && <span>{t("user.verifyAccount.passwordsDoNotMatch")}</span>}
                  </div>
                </div>
                <div className="flex AccountActivatebtnbox">
                  <div className="form-group pt-3">
                    <Button
                      type="submit"
                      className="btn btn-secondary-own btn-block btn-own "
                    >
                      <span className=" text-color-primary">{t("user.verifyAccount.submitButton")}</span>
                    </Button>
                  </div>
                  <div className="pt-2 text-center pb-3">
                    <Link to={`/${props.roleType}/login`}>
                      <span className="text-white"><i className="fas fa-arrow-left" style={{ marginRight: '5px' }}></i> {t("user.verifyAccount.backToLogin")}</span>
                    </Link>
                  </div>
                </div>

              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(VerifyAccount);
